import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { getMyProfilePicture } from '../../Services/PtaasApiService';
import { useMsal } from '@azure/msal-react';

type ProfileContextType = {
  profilePicUrl: string;
  setProfilePicUrl: (url: string) => void;
  
};

const defaultState: ProfileContextType = {
  profilePicUrl: '',
  setProfilePicUrl: () => {},
  
};


// Creating the context with default state
const ProfileContext = createContext<ProfileContextType>(defaultState);

type ProfileProviderProps = {
  children: ReactNode;
};

export const ProfileProvider = ({ children }: ProfileProviderProps) => {
  const [profilePicUrl, setProfilePicUrl] = useState<string>('');
  
  const { instance,accounts } = useMsal();

  useEffect(() => {
    // No signed-in account yet (first render before MSAL resolves): nothing to load.
    if (!accounts[0]) return;

    let objectUrl: string | undefined;
    let cancelled = false;

    const loadProfilePic = async () => {
      try {
        const imageData = await getMyProfilePicture(instance, accounts[0]);
        objectUrl = URL.createObjectURL(imageData); // Create a URL for the Blob
        if (!cancelled) setProfilePicUrl(objectUrl);
      } catch (error) {
        console.error("Failed to load profile picture:", error);
      }
    };
    loadProfilePic();

    // Revoke the blob URL on cleanup so re-runs (account change / remount) don't
    // leak a growing set of object URLs that live until the tab closes.
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instance, accounts[0]?.homeAccountId]);

  return (
    <ProfileContext.Provider value={{ profilePicUrl, setProfilePicUrl}}>
      {children}
    </ProfileContext.Provider>
  );
};
// Export the use of context
export const useProfileContext = () => useContext(ProfileContext);

